import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
  AfterViewChecked
} from '@angular/core';
import { ListItem } from '../../models/list-item';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'ispm-generic-list',
  templateUrl: './generic-list.component.html',
  styleUrls: ['./generic-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenericListComponent implements AfterViewChecked {

  @Output() selectedItemEmitter = new EventEmitter<any>();

  @Input() maxHeight;
  @Input() items$: BehaviorSubject<Array<ListItem>> = new BehaviorSubject<Array<ListItem>>([]);

  trackByFn(index, item: ListItem) {
    return item.id;
  }

  ngAfterViewChecked(): void {
    const element = document.getElementById('items-list');
    element.style.maxHeight = this.maxHeight;
    element.scrollTop = element.scrollHeight;
  }
}
